import React from "react";
import { Tag, tomDoStatus } from "./ui";

/**
 * Lista "premium" (Opção A): cada registro é uma linha espaçada com uma
 * inicial colorida à esquerda, título + subtítulo, uma pílula de status, um
 * valor à direita e um chevron. Usada em Contratos, Processos e Pagamentos.
 *
 * Props de cada item (função `mapear` transforma o dado bruto):
 *   { chave, iniciais, titulo, subtitulo, status, statusTom, direita, aoClicar }
 */

/** Gera 1-2 iniciais a partir de um nome */
export function iniciaisDe(nome) {
    if (!nome) return "—";
    const partes = String(nome).trim().split(/\s+/);
    return (partes[0][0] + (partes[1]?.[0] || "")).toUpperCase();
}

const ListaPremium = ({ itens, vazio = "Nenhum registro encontrado." }) => {
    if (!itens.length) {
        return <p className="text-muted">{vazio}</p>;
    }

    return (
        <div className="lista-premium">
            {itens.map((item) => (
                <button key={item.chave} className="lp-linha" onClick={item.aoClicar}>
                    <span className={`lp-inicial ${item.inicialTom ? "lp-inicial-" + item.inicialTom : ""}`}>
                        {item.iniciais}
                    </span>
                    <span className="lp-corpo">
                        <span className="lp-titulo">{item.titulo}</span>
                        {item.subtitulo && <span className="lp-sub">{item.subtitulo}</span>}
                        {item.progresso != null && (
                            <span className="lp-barra" aria-hidden="true">
                                <span
                                    className={`lp-barra-fill lp-barra-${item.progressoTom || "accent"}`}
                                    style={{ width: `${Math.min(100, Math.max(0, item.progresso * 100))}%` }}
                                />
                            </span>
                        )}
                    </span>
                    {item.status && (
                        <Tag tom={item.statusTom || tomDoStatus(item.status)}>{item.status}</Tag>
                    )}
                    {item.direita != null && <span className="lp-direita">{item.direita}</span>}
                    <svg className="lp-chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="m9 18 6-6-6-6" />
                    </svg>
                </button>
            ))}
        </div>
    );
};

export default ListaPremium;
